import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { IncomingOutgoingAmlContent, TransactionTypeEnum } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemOutgoingTransaction from '../hooks/use-outgoing';

const ProblemOutgoingTransactionAmlContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const { aml } = useAppSelector(
    (state) => state.customersProblemTransactions.outgoing,
  );

  const { isLoadingAml, getOutgoingAmlAction } = useProblemOutgoingTransaction({
    transactionId,
  });

  useEffect(() => {
    if (!aml && transactionId) {
      getOutgoingAmlAction();
    }
  }, [getOutgoingAmlAction, aml, transactionId]);

  return (
    <IncomingOutgoingAmlContent
      isLoading={isLoadingAml}
      aml={aml}
      transactionType={TransactionTypeEnum.OUTGOING}
    />
  );
};

export default ProblemOutgoingTransactionAmlContentHOC;
